/**
 * VH-83: Red banner shown on the recipe detail view when a recipe needs
 * equipment the user hasn't configured (or higher oven temp than supported).
 */

import { useTranslation } from 'react-i18next'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'

export default function EquipmentMismatchBanner({ compat }) {
  const { t } = useTranslation()

  if (!compat || compat.compatible) return null

  const missing = compat.missing_equipment || []
  const tempSteps = compat.unsupported_temp_steps || []

  return (
    <div className="rounded-lg border border-red-200 bg-red-50 p-4 mb-4">
      <div className="flex gap-3">
        <ExclamationTriangleIcon className="h-5 w-5 flex-shrink-0 text-red-500 mt-0.5" />
        <div className="flex-1">
          <h4 className="text-sm font-semibold text-red-800">
            {t('recipes.mismatch.title')}
          </h4>
          {missing.length > 0 && (
            <p className="text-sm text-red-700 mt-1">
              {t('recipes.mismatch.missing', {
                items: missing
                  .map((k) =>
                    t(`recipes.equipment.labels.${k}`, k)
                  )
                  .join(', '),
              })}
            </p>
          )}
          {tempSteps.length > 0 && (
            <ul className="mt-1 list-disc list-inside text-sm text-red-700 space-y-0.5">
              {tempSteps.map((s, idx) => (
                <li key={s.step_id ?? idx}>
                  {t('recipes.mismatch.tempStep', {
                    step: s.step_order ?? idx + 1,
                    required: s.required_temp_c,
                    max: s.max_supported_c,
                  })}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  )
}
